module.exports = __webpack_public_path__ + "img/closing.33a2b3f6.svg";